import { useContext } from "react"
import { Grid, MenuItem, TextField } from "@material-ui/core";
import { FilterContainer, SearchButton } from "components"
import { serialNumbersContext } from "../SerialNumbersProvider"

let Filters = () => {
    let service = useContext(serialNumbersContext);

    return (
        <FilterContainer onSubmit={() => service.doSearch()}>
            <Grid item xs={2}>
                <TextField
                    variant="outlined"
                    label="Serial number"
                    value={service.search.serialNumber}
                    onChange={(e) => service.updateSearch({ ...service.search, serialNumber: e.target.value })}
                />
            </Grid>
            <Grid item xs={2}>
                <TextField
                    variant="outlined"
                    label="Customer email"
                    type="email"
                    value={service.search.customerEmail}
                    onChange={(e) => service.updateSearch({ ...service.search, customerEmail: e.target.value })}
                />
            </Grid>
            <Grid item xs={2}>
                <TextField
                    select
                    variant="outlined"
                    label="Show"
                    value={service.search.onlyUsedSerialNumbers}
                    onChange={(e) => service.updateSearch({ ...service.search, onlyUsedSerialNumbers: e.target.value })}
                >
                    <MenuItem value=''>Any serial numbers</MenuItem>
                    <MenuItem value='true'>Only used serial numbers</MenuItem>
                    <MenuItem value='false'>Only unused serial numbers</MenuItem>
                </TextField>
            </Grid>

            <Grid item xs>
                <SearchButton type='submit' />
            </Grid>
        </FilterContainer>
    )
}

export default Filters;